import {useContext} from "react";
import {FormContext} from "~/components/forms/FormContext";
import Modal from "~/components/Modal";
import ThemedForm from "~/components/forms/ThemedForm";

const ThemedModal = ({isOpen, onClose, children, ...props}) => {
    const { form } = useContext(FormContext);

    return (
        <Modal isOpen={isOpen} onClose={onClose} {...props}>
            <ThemedForm styles={form?.settings?.styles}>
                {children}
            </ThemedForm>
        </Modal>
    )
}

export default ThemedModal;
